// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_search = /** @type {(inputs: {}) => string} */ () => {
	return `Search...`
};

const el_search = /** @type {(inputs: {}) => string} */ () => {
	return `Αναζήτηση...`
};

const ru_search = /** @type {(inputs: {}) => string} */ () => {
	return `Поиск...`
};

const he_search = /** @type {(inputs: {}) => string} */ () => {
	return `חיפוש...`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const search = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.search(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("search", locale)
	if (locale === "en") return en_search(inputs)
	if (locale === "el") return el_search(inputs)
	if (locale === "ru") return ru_search(inputs)
	if (locale === "he") return he_search(inputs)
	return "search"
};